import React from 'react';
import css from 'styled-jsx/css';
import CategoryItem from './CategoryItem';
import withI18next from '~/../hocs/_withI18next';
import themeVariables from '~/shared/themeVariables';

const CategoriesGrid = ({ t, categories, serviceType }) => {
  return (
    <div className="categories">
      {categories.map((category) => (
        <CategoryItem
          key={category.id}
          t={t}
          category={category}
          serviceType={serviceType}
        />
      ))}
      <style jsx>{styles}</style>
    </div>
  );
};

const styles = css`
  .categories {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    grid-gap: 24px;
    justify-content: space-between;
    margin-top: 28px;
  }

  @media (max-width: ${themeVariables.breakpoints.tabletS.maxWidth}px) {
    .categories {
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      grid-gap: 10px;
    }
  }
  @media (min-width: ${themeVariables.breakpoints.tabletL
      .minWidth}px) and (max-width: ${themeVariables.breakpoints.desktopMedium
      .maxWidth}px) {
    .categories {
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      grid-gap: 10px;
    }
  }
`;

export default withI18next()(CategoriesGrid);
